import { medications } from '../data/medications';
import { complementaryProducts } from '../data/complementaryProducts';

const deg2rad = (deg) => deg * (Math.PI / 180);

export const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
  const R = 6371;
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  return d.toFixed(1);
};

export const formatCurrency = (amount) => `$${amount.toFixed(2)}`;

export const calculateDeliveryTime = (distance) => {
  const baseTime = 30;
  const timePerKm = 5;
  return Math.round(baseTime + (parseFloat(distance) * timePerKm));
};

export const getComplementaryProducts = (cart, pharmacy, userProfile, excludedIds = []) => {
  const suggestions = new Map();
  const cartCategories = cart.length > 0
    ? [...new Set(cart.map(item => medications.find(m => m.id === item.id)?.category))]
    : [];
  const userAge = userProfile.demographics.age;
  const userGender = userProfile.demographics.gender;

  complementaryProducts.forEach(product => {
    let score = 0;
    const productId = product.id;

    if (excludedIds.includes(productId)) return;
    if (cart.some(item => item.id === productId)) return;
    if (!pharmacy.stock[productId] || pharmacy.stock[productId] === 0) return;

    if (product.relatedTo && cart.length > 0) {
      cartCategories.forEach(category => {
        if (product.relatedTo.includes(category)) {
          score += 30;
        }
      });
    }

    if (product.demographics) {
      if (product.demographics.age &&
          userAge >= product.demographics.age[0] &&
          userAge <= product.demographics.age[1]) {
        score += 20;
      }
      if (product.demographics.gender && product.demographics.gender === userGender) {
        score += 15;
      }
    }

    const conditionAssociations = {
      'Diabetes': ['Blood Pressure', 'Cholesterol', 'Heart Health'],
      'Blood Pressure': ['Cholesterol', 'Heart Health', 'Diabetes'],
      'Mental Health': ['Digestive', 'Pain Relief'],
      'Cholesterol': ['Blood Pressure', 'Heart Health'],
      'Respiratory': ['General Health']
    };

    cartCategories.forEach(cartCat => {
      const associations = conditionAssociations[cartCat] || [];
      if (associations.includes(product.category)) {
        score += 10;
      }
    });

    if (userAge >= 50 && ['Vitamins', 'Heart Health', 'Digestive'].includes(product.category)) {
      score += 5;
    }

    if (['General Health', 'First Aid'].includes(product.category)) {
      score += 3;
    }

    if (score > 0 || cart.length === 0) {
      suggestions.set(productId, { ...product, score, stockLevel: pharmacy.stock[productId] });
    }
  });

  if (cart.length === 0) {
    complementaryProducts.forEach(product => {
      if (!excludedIds.includes(product.id) && pharmacy.stock[product.id] > 0) {
        const score = product.demographics && product.demographics.age &&
          userAge >= product.demographics.age[0] &&
          userAge <= product.demographics.age[1] ? 10 : 5;
        suggestions.set(product.id, { ...product, score, stockLevel: pharmacy.stock[product.id] });
      }
    });
  }

  return Array.from(suggestions.values())
    .sort((a, b) => b.score - a.score)
    .slice(0, 8);
};
